import { useState, type ReactNode } from 'react';
import type { PropertyDetail } from '@/types/custom-types';
import { PropertyDetailsContext } from './PropertyDetailsContext';

export const PropertyDetailsContextProvider = ({ children }: { children: ReactNode }) => {
  const [property, setProperty] = useState<PropertyDetail | undefined>(() => {
    const storedId = sessionStorage.getItem("propertyId");
    return storedId ? { id: storedId, address: {} } : undefined;
  });

  return (
    <PropertyDetailsContext.Provider value={{ property, setProperty }}>
      {children}
    </PropertyDetailsContext.Provider>
  );
};
